// src/environments/production.ts
import environment from './base';

const baseApi = 'http://localhost:4000/api/v1';

const env = environment(baseApi);
const data = {
  ...env,
  isMock: false,
  authAPI: 'https://2factor.in/API/V1',
  api: 'https://api.playzuno.com/api/v1',
  apiKey: '0fb4a6ea-c9a3-11e5-9a14-00163ef91450'
}

export default data;